import { useEffect, useState } from 'react'

import Loader from 'react-loaders'

import WordCloud from './wordcloud'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Skills = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const skillsArray = 'Skills'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container skills-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={skillsArray}
              idx={15}
            />
            <br />
          </h1>
          <p>
            I have 10+ years building blockchain systems—from smart contracts and
            MPC custody to Hyperledger and Cosmos-based architectures. My
            experience spans Solidity, Rust, Go, Node.js, and Python, with
            deep expertise in token standards, upgradeable contracts, and
            compliant RWA ecosystems.
          </p>
          <p>
            My skill set spans Web3 development, smart contract security,
            backend APIs, cloud infrastructure, and CI/CD. I'm committed to
            staying updated with the latest blockchain advancements and
            continually refining my expertise to deliver production-grade systems.
          </p>
        </div>

        <div className="tagcloud-wrap">
          <WordCloud />
        </div>
      </div>

      <Loader type="pacman" />
    </>
  )
}

export default Skills
